import triggerEventClick from './trigger-event-click'

const trackLink = (data) => {
  if (data.eventAction || data.event) {
    let pageContext = data.pageContext

    // Add Chapter Number (For DbD)
    let product = null
    if (data.trigger === 'buyModal' && (data.eventType === 'chapter' || data.eventType === 'character')) {
      product = data.link
      pageContext = { ...data.pageContext, product }
    }

    // Custom events
    // Pass an array containing the custom key and value to track. Ex.: [ "chapterName", "ch28.5 nicolas cage" ]
    let eventCustom = data.eventCustom

    let trackingData = {
      pageContext: pageContext,
      eventCategory: data.eventCategory,
      eventAction: data.eventAction,
      eventType: data.eventType,
      eventLocation: data.eventLocation,
      eventLabel: data.eventLabel,
      eventElement: data.eventElement,
      eventCustom: eventCustom,
      event: data.event,
      section: data.eventSection ? data.eventSection : data.section,
      vendor: data.vendor,
      page: data.eventPage
    }
    triggerEventClick(trackingData)
  }
}

export default trackLink